import React from 'react';
import { resources } from '../resources.js';
import withAuthProvider, { AuthComponentProps } from '../Auth/AuthProvider';
import { getCalendar, createEvent, postEvent, getEvents, deleteEvents, getEventInstances } from '../GraphUtil/CalendarService';
import {
    Button,
} from 'reactstrap';
import pLimit from 'p-limit';
import { getHolidays, getTerm } from '../Util/TimetableUtil';
import ErrorMessage from '../Util/ErrorMessage';

interface CalendarSyncProps extends AuthComponentProps {
    timetable: any,
    exportedArray: any,
    hasTimetable: boolean
}

interface CalendarSyncState {
    response: {},
    error: any,
    syncText: string,
    syncColor: string,
    syncComplete: boolean,
    exportArr: any
}

class CalendarSync extends React.Component<CalendarSyncProps, CalendarSyncState> {
    constructor(props: any) {
        super(props);
        this.state = {
            response: {},
            error: null,
            syncText: "Copy to Outlook Calendar",
            syncColor: "primary",
            syncComplete: false,
            exportArr: [],
        };
    }

    setErrorMessage(title: string, message: string, debug: string) {
        this.setState({
            error: { title: title, message: message, debug: debug }
        });
    }

    postTimetable = async () => {
        if (this.props.user && !this.state.syncComplete) {
            try {
                // Get the user's access token
                var accessToken = await this.props.getAccessToken(resources.graph.scopes);

                // Get Calendar Id (default)
                var calendarId = await getCalendar(accessToken);

                // Get OLD McMaster Category Events
                var getEventsResponse = await getEvents(accessToken, calendarId, getTerm().termStartDate, getTerm().termEndDate);
                console.log(getEventsResponse);

                // Limit concurrent outlook connections to 4
                const limit = pLimit(4);

                // Get holidays array
                var getHolidaysResponseObject = await getHolidays();
                console.log(getHolidaysResponseObject);

                // Delete OLD McMaster Category Events
                getEventsResponse.value.map((event: any) => limit(async () => await deleteEvents(accessToken, calendarId, event.id)));

                // Blow away unchecked events in timetable from ExportedArr props
                // Init exportedArray if props is undefined due to state not changing on initial render
                console.log("Exported Array: " + this.props.exportedArray);
                if (typeof this.props.exportedArray == 'undefined' || this.props.exportedArray == null) {
                    this.setState({ exportArr: new Array(this.props.timetable.length).fill(true) })
                } else {
                    this.setState({ exportArr: this.props.exportedArray })
                }

                // Map thru exported array and splice timetable sections and produce final timetable to base events from
                var timetableFinal = [...this.props.timetable];
                var spliceCounter = 0;

                //console.log("Timetable Final Before Map: " + timetableFinal);
                //console.log("CalendarSync State Before Map: " + this.state.exportArr);

                this.state.exportArr.map((x: any, index: any) => {
                    if (!x) {
                        timetableFinal.splice(index - spliceCounter, 1);
                        spliceCounter++;
                    }
                })

                //console.log("Timetable Final After Map: " + timetableFinal);

                // Create New Events
                // Map timetable and create new event per entry
                var postEventResponseObject = timetableFinal.map(async (sections: any) => {

                    // Create Event Object per course meeting pattern
                    sections.meetings.map(async (meeting: any) => {
                        var event = createEvent(sections, meeting);
                        limit(async () => postEvent(accessToken, event, calendarId)).then(async postEventResponse => {

                            // For each holiday, map and get event instances, delete instances
                            getHolidaysResponseObject.holidays.map((holidays: any) => {

                                limit(async () =>
                                    getEventInstances(accessToken, calendarId, holidays.date + 'T00:00:00.0000000', holidays.date + 'T23:59:00.0000000', postEventResponse.id)
                                        .then(async x => {
                                            if (typeof x.value[0]?.id !== 'undefined') {
                                                await deleteEvents(accessToken, calendarId, x.value[0]?.id)
                                            }
                                        })
                                );

                            });
                        });

                    })

                })

                // Success, update state
                this.setState({
                    response: JSON.stringify(postEventResponseObject),
                    syncText: "Complete",
                    syncColor: "success",
                    syncComplete: true
                });

            }
            catch (err) {
                this.setErrorMessage("Error", "Microsoft Graph API Error", JSON.stringify(err));
            }
        }
    }

    render() {

        let error = null;
        if (this.state.error) {
            error = <ErrorMessage
                title={this.state.error.title}
                message={this.state.error.message}
                debug={this.state.error.debug}
            />;
        }

        return (
            <div>
                <h2 className="card-title">Copy to Outlook Calendar</h2>
                <Button className="btn-primary" href={void (0)} color={this.state.syncColor} role="button" disabled={this.state.syncComplete} onClick={this.postTimetable}>{this.state.syncText}</Button>
                {error}
            </div>


        )
    }

}

export default withAuthProvider(CalendarSync);